import React from "react";
import AppQuiz from "./Quiz/Quiz";
function App() {
  return (
    <div>
      <AppQuiz/>
    </div>
  );
}

export default App;
